module.exports = __webpack_public_path__ + "img/305910224.572dc604.jpg";